import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SessionQuery } from '../../core/state-mangement/session/session.query';
import { LocalStorageService } from '../../core/services/local-storage.service';
import { SessionService } from '../../core/state-mangement/session/session.service';
import { BackendQuery } from '../../core/state-mangement/backend/backend.query';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.page.html',
  styleUrls: ['./splash-screen.page.scss'],
})
export class SplashScreenPage implements OnInit, OnDestroy {
  $visible = new BehaviorSubject<boolean>(true);

  private subs = new Subscription();

  constructor(
    private sessionQuery: SessionQuery,
    private backendQuery: BackendQuery,
    private sessionService: SessionService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.setupBackendCheck();
    this.setupUserInfoCheck();
    this.setupSplashVisibility();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  private setupBackendCheck() {
    if (
      !this.backendQuery.getValue()?.online &&
      this.sessionService.isLoggedIn()
    ) {
      this.sessionService.logout();
    }
    this.$visible.next(false);
  }

  private setupUserInfoCheck() {
    this.subs.add(
      this.localStorageService.getKey('UserInfo').subscribe((value) => {
        const delay = value ? 1000 : 0;
        setTimeout(() => this.$visible.next(false), delay);
      })
    );
  }

  private setupSplashVisibility() {
    this.subs.add(
      this.sessionQuery.showSplash$.subscribe((value) => {
        if (value) {
          this.$visible.next(true);
          setTimeout(() => {
            this.$visible.next(false);
            this.sessionService.dontShowSplash();
          }, 1000);
        }
      })
    );
  }
}
